import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ProjectCommentArrayModel,
  ProjectCommentModel,
} from "../../models/ProjectCommentModel";
import { generateRandomNumber } from "../../utility/utils";

const initialProjectCommentState: ProjectCommentArrayModel = {
  all_ProjectComments: [],
  particular_ProjectComment: {
    projectCommentId: 0,
    projectId: 0,
    creationDate: new Date(),
    commenterName: "",
    commenterUserId: 0,
    commentText: "",
  },
  project_creation_comment: {
    projectCommentId: 0,
    projectId: 0,
    creationDate: new Date(),
    commenterName: "",
    commenterUserId: 0,
    commentText: "",
  },
  particularProject_AllComments: [],
};
const ProjectCommentSlice = createSlice({
  name: "ProjectComment",
  initialState: initialProjectCommentState,
  reducers: {
    setProjectComments(state, action: PayloadAction<ProjectCommentModel[]>) {
      state.all_ProjectComments = action.payload;
    },
    setParticularProjectComment(
      state,
      action: PayloadAction<ProjectCommentModel>
    ) {
      state.particular_ProjectComment = action.payload;
    },
    setParticularProjectAllComments(
      state,
      action: PayloadAction<ProjectCommentModel[]>
    ) {
      state.particularProject_AllComments = action.payload;
    },
    appendProjectComment(state, action: PayloadAction<ProjectCommentModel>) {
      state.particularProject_AllComments.push({
        ...action.payload,
        projectCommentId: generateRandomNumber(),
      });
    },
    setProjectCreationComment(
      state,
      action: PayloadAction<ProjectCommentModel>
    ) {
      state.project_creation_comment = action.payload;
    },
  },
});
export default ProjectCommentSlice;
